function baseUrl() {
  const url = window.location
  return url.protocol + "//" + url.host + "/" + url.pathname.split('/')[1];
}

function setViewportDimensions() {
  const bodyWidth = window.innerWidth
  const bodyHeight = window.innerHeight
  document.body.style.width = bodyWidth + 'px'
  document.body.style.height = bodyHeight + 'px'
  let wrapper = document.querySelector('#wrapper')
  const ratio = 1.77
  if( ( bodyWidth / bodyHeight ) > ratio ) {
    wrapper.style.width = (bodyHeight * ratio) - 1 + 'px'
    wrapper.style.height = bodyHeight - 1 + 'px'
  }
  else {
    wrapper.style.width = bodyWidth - 1 + 'px'
    wrapper.style.height = (bodyWidth / ratio) - 1 + 'px'
  }
}

function setSceneStatus(sceneName) {
  document.body.setAttribute('data-scene', sceneName)
}

export {baseUrl, setViewportDimensions, setSceneStatus}
